import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import HaldorAssignment from './HaldorAssignment';
import MicrosoftAssignment from './MicrosoftAssignment';
import { getGuardianStudentAssignment, getGuardianStudentAssignmentAssessments, getGuardianStudentAssessments, getTeamsAssignments } from 'actions/assignments';
import { Spinner } from 'UI';
var AssignmentWrapper = /*#__PURE__*/function (_Component) {
  function AssignmentWrapper(props) {
    var _this;
    _classCallCheck(this, AssignmentWrapper);
    _this = _callSuper(this, AssignmentWrapper, [props]);
    _this.state = {
      loading: true
    };
    return _this;
  }
  _inherits(AssignmentWrapper, _Component);
  return _createClass(AssignmentWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var activeStudent = this.props.activeStudent;
      var assignmentId = this.props.match.params.assignmentId;
      if (assignmentId == parseInt(assignmentId, 10)) {
        this.props.getGuardianStudentAssignment(activeStudent.id, assignmentId).then(function () {
          _this2.setState({
            loading: false
          });
        });
      } else {
        if (this.props.assignments == null || this.props.assignments.length == 0) {
          this.props.getTeamsAssignments(this.props.activeStudent.id).then(function () {
            _this2.setState({
              loading: false
            });
          });
        } else {
          this.setState({
            loading: false
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var assignmentId = this.props.match.params.assignmentId;
      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }
      var task = null;
      if (assignmentId == parseInt(assignmentId, 10) && this.props.task.externalId === null) {
        task = this.props.task;
      } else {
        task = this.props.assignments.find(function (assignment) {
          return assignment.externalId == assignmentId;
        });
      }
      if (task.externalId == null) {
        return /*#__PURE__*/React.createElement(HaldorAssignment, this.props);
      }
      return /*#__PURE__*/React.createElement(MicrosoftAssignment, _extends({}, this.props, {
        task: task
      }));
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    task: state.assignments.assignment,
    assignments: state.assignments.assignments,
    activeStudent: state.User.activeStudent
  };
};
export default connect(mapStateToProps, {
  getGuardianStudentAssignment: getGuardianStudentAssignment,
  getGuardianStudentAssignmentAssessments: getGuardianStudentAssignmentAssessments,
  getGuardianStudentAssessments: getGuardianStudentAssessments,
  getTeamsAssignments: getTeamsAssignments
})(AssignmentWrapper);